export default __webpack_public_path__ + "images/9a7241ccab9c52727af1a1a1662d8438.png";